import { render, staticRenderFns } from "./ResultModal.vue?vue&type=template&id=42faa66f&scoped=true&"
import script from "./ResultModal.vue?vue&type=script&lang=ts&"
export * from "./ResultModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42faa66f",
  null
  
)

export default component.exports